/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
    <div class="main-container" id="rootConainer">
        <el-container>
            <el-aside :style="{ width: 'auto' }" class="side-bar">
                <LogoHeader></LogoHeader>
                <el-scrollbar style="height: 100%">
                    <MenuBar class="menuCont"></MenuBar>
                </el-scrollbar>
                <!-- <collapseBtn></collapseBtn> -->
            </el-aside>
            <el-container>
                <el-header>
                    <Header></Header>
                    <el-row type="flex">
                        <!-- <el-col :span="editableTabs.length > 1 ? 23 : 24"> -->
                        <div class="my-col">
                            <el-tabs
                                v-model="editableTabsValue"
                                @tab-remove="removeTab"
                                @tab-click="handleClickTab"
                                closable
                                type="card"
                                @edit="handleTabsEdit"
                                class="main-tabs"
                            >
                                <el-tab-pane
                                    :key="index"
                                    v-for="(item, index) in editableTabs"
                                    :label="item.title"
                                    :name="item.name"
                                ></el-tab-pane>
                            </el-tabs>
                        </div>
                        <!-- </el-col> -->
                        <transition name="fade" :duration="1000">
                            <!-- <el-col
                                :span="1"
                                style="text-align: right"
                                v-show="editableTabs.length > 1"
                            > -->
                            <div v-show="editableTabs.length > 1">
                                <el-dropdown @command="tabCommand">
                                    <el-button
                                        class="aside_btn"
                                        icon="el-icon-arrow-down"
                                        size="small"
                                    ></el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="current"
                                            >关闭当前标签</el-dropdown-item
                                        >
                                        <el-dropdown-item command="right"
                                            >关闭右侧</el-dropdown-item
                                        >
                                        <el-dropdown-item command="left"
                                            >关闭左侧</el-dropdown-item
                                        >
                                        <el-dropdown-item command="all"
                                            >关闭全部</el-dropdown-item
                                        >
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <!-- </el-col> -->
                        </transition>
                    </el-row>
                </el-header>
                <el-main class="main-inner">
                    <div class="main-content">
                        <keep-alive
                            :include="this.$store.state.whileList"
                            :exclude="this.$store.state.blackList"
                        >
                            <router-view></router-view>
                        </keep-alive>
                        <!-- <router-view></router-view> -->
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import Header from "./header";
import MenuBar from "./menu-bar";
import LogoHeader from "./logo-header";
import collapseBtn from "./collapseBtn";
import { mapState } from "vuex";
export default {
    name: "Main",
    components: {
        Header: Header,
        MenuBar: MenuBar,
        LogoHeader: LogoHeader,
        collapseBtn: collapseBtn,
    },
    data() {
        return {
            editableTabsValue: "",
            editableTabsLabel: "",
            hasStatus: false,
            editableTabs: [],
            width: 180,
            userRole: "",
        };
    },
    computed: {
        menuList() {
            return JSON.parse(localStorage.getItem("menu_list"));
        },
        ...mapState({
            userTypeList: (state) => state.index.userTypeList,
        }),
        userTypeList() {
            return this.$store.state.index.userTypeList;
        },
    },
    created() {
        this.$store.dispatch("getMenuListByRoles");
        // this.$store.dispatch("getCodeList");
        this.$store.dispatch("getUserInfo");
    },
    beforeRouteEnter(to, from, next) {
        const token = localStorage.getItem("token");
        if (to.name === "main" && !token) {
            // next("/login");
            location.href = `${process.env.VUE_APP_AUTH_URL}/user/login?redirect=${encodeURIComponent(location.href)}`;
        }
        return next((vm) => {
            if (to.path !== "/") {
                vm.hasStatus = false;
                if (vm.editableTabs.length) {
                    //   tab有值判断数组是否有重复值，没有直接添加，有的话，设置选中
                    vm.editableTabs.forEach((item) => {
                        if (item.title === vm.editableTabsLabel) {
                            vm.hasStatus = true;
                        }
                    });
                    if (!vm.hasStatus && vm.editableTabsLabel) {
                        vm.editableTabs.push({
                            title: vm.editableTabsLabel,
                            name: to.name,
                            path: to.fullPath,
                        });
                    }
                } else {
                    vm.editableTabs.push({
                        title: to.meta.title,
                        name: to.name,
                        path: to.fullPath,
                    });
                }

                if (!localStorage.getItem("activeTab")) {
                    localStorage.setItem("activeTab", to.name);
                }
                vm.editableTabsValue = to.name;
                localStorage.setItem(
                    "tabList",
                    JSON.stringify(vm.editableTabs)
                );
            }
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.editableTabsLabel = localStorage.getItem("activeTabLabel");
        this.hasStatus = false;
        if (this.editableTabs.length) {
            //   tab有值判断数组是否有重复值，没有直接添加，有的话，设置选中
            this.editableTabs.forEach((item) => {
                if (
                    item.title.includes(this.editableTabsLabel) ||
                    this.editableTabsLabel.includes(item.title)
                ) {
                    item.title = this.editableTabsLabel;
                }
                if (item.title === this.editableTabsLabel) {
                    this.hasStatus = true;
                }
            });
            if (!this.hasStatus && this.editableTabsLabel) {
                this.editableTabs.push({
                    title: this.editableTabsLabel,
                    name: to.name,
                    path: to.fullPath,
                });
            }
        } else {
            this.editableTabs.push({
                title: this.editableTabsLabel,
                name: to.name,
                path: to.fullPath,
            });
        }
        this.editableTabsValue = localStorage.getItem("activeTab")
            ? localStorage.getItem("activeTab").replace("/", "")
            : to.name;
        this.editableTabsValue = to.name;
        localStorage.setItem("activeTab", this.editableTabsValue);
        if (JSON.parse(localStorage.getItem("tabList"))) {
            localStorage.setItem(
                "tabList",
                JSON.stringify(this.editableTabs)
            );
        } else {
            this.editableTabs = [
                {
                    title: this.editableTabsLabel,
                    name: to.name,
                    path: to.fullPath,
                },
            ];
            localStorage.setItem("tabList", JSON.stringify([]));
        }
        next();
    },
    // keepAlive缓存
    beforeRouteLeave(to, from, next) {
        if (from.meta.keepAlive) {
            this.$store.commit("add_whiteList", from.name);
            next();
        } else {
            this.$store.commit("add_blackList".from.name);
            next();
        }
    },
    mounted() {
        const tabList = JSON.parse(localStorage.getItem("tabList"));
        const tabActive = localStorage.getItem("activeTab");
        const tabActiveLabel = localStorage.getItem("activeTabLabel");
        if (tabList) {
            this.editableTabs = tabList;
            this.editableTabsValue = tabActive;
            this.editableTabsLabel = tabActiveLabel;
        }
    },

    methods: {
        /**
         * 删除tab标签
         */
        removeTab(targetName) {
            if (targetName === "home") {
                return false;
            }
            let tabs = this.editableTabs;
            let activeName = this.editableTabsValue;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.name;
                            this.editableTabsLabel = nextTab.title;
                        }
                    }
                });
            }
            this.editableTabsValue = activeName;
            this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
            let path = tabs.filter((tab) => tab.name === activeName)[0].path;
            localStorage.setItem("activeTab", this.editableTabsValue);
            localStorage.setItem("activeTabLabel", this.editableTabsLabel);
            localStorage.setItem(
                "tabList",
                JSON.stringify(this.editableTabs)
            );
            this.$router.push(path);
        },
        /**
         * 点击tab
         */
        handleClickTab(tab) {
            let menu_id = this.tabRecursion("/" + tab.name, this.menuList);
            localStorage.setItem("menu_id", menu_id);
            this.$store.commit("MENU_ID", menu_id);
            this.$store.dispatch("getMenuAuth");
            this.editableTabsValue = tab.name;
            this.editableTabsLabel = tab.label;
            localStorage.setItem("activeTab", this.editableTabsValue);
            localStorage.setItem("activeTabLabel", this.editableTabsLabel);

            this.$router.push("/" + tab.name);
        },
        /**
         * tab点击循环menulist获取menu_id的递归
         */
        tabRecursion(_target, list) {
            for (let i in list) {
                if (_target == list[i].url) {
                    return list[i].id;
                } else if (list[i].child && list[i].child.length) {
                    let func = this.tabRecursion(_target, list[i].child);
                    if (func) {
                        return func;
                    }
                }
            }
            return "";
        },
        /**
         * 获取重定向路由
         */
        getReplaceUrl(menuList) {
            if (menuList[0].childlist) {
                if (menuList[0].childlist[0].childlist) {
                    this.replaceUrl =
                        menuList[0].childlist[0].childlist[0].route_path;
                } else {
                    this.replaceUrl = menuList[0].childlist[0].route_path;
                }
            } else {
                this.replaceUrl = menuList[0].route_path;
            }
        },
        /**
         * 清楚所有选项卡
         */
        clearTabs() {
            this.$confirm("是否清除所有选项卡?", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.editableTabs = [
                        {
                            title: "首页",
                            name: "home",
                            path: "/home",
                        },
                    ];
                    localStorage.setItem(
                        "tabList",
                        JSON.stringify(this.editableTabs)
                    );
                    localStorage.setItem(
                        "activeTab",
                        this.editableTabs[0].name
                    );
                    localStorage.setItem(
                        "activeTabLabel",
                        this.editableTabs[0].title
                    );
                    this.$router.push(this.editableTabs[0].path);
                    this.$message.success("清除成功！");
                })
                .catch(() => {
                    this.$message.info("已取消操作");
                });
        },
        // 关闭选项卡
        tabCommand(directive) {
            let _this = this;
            function mapTabs() {
                _this.editableTabs.map((item, index, arr) => {
                    if (item.name == _this.editableTabsValue) {
                        if (directive === "right") {
                            arr.splice(index + 1, arr.length - 1);
                        } else if (directive === "left") {
                            if (_this.editableTabsValue === "home") {
                                return false;
                            }
                            arr.splice(1, index - 1);
                        } else if (directive === "current") {
                            arr.splice(index, 1);
                            _this.editableTabsValue = arr[index - 1].name;
                            _this.$router.push(arr[index - 1].path);
                        }
                        // 设置session
                        localStorage.setItem(
                            "tabList",
                            JSON.stringify(_this.editableTabs)
                        );
                    }
                });
            }
            let strategyGroup = {
                current: () => {
                    mapTabs();
                },
                right: () => {
                    mapTabs();
                },
                left: () => {
                    mapTabs();
                },
                all: () => {
                    this.clearTabs();
                },
            };

            let action = (directive) => {
                strategyGroup[directive]();
            };
            action(directive);
        },
    },
};
</script>
<style lang="scss">
.main-container {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #fff;
    overflow: hidden;
    .main-tabs {
        // margin: -4px 0 0 0;
        // border-bottom: 1px solid #d8d8d8;
        // border-top: 1px solid #d8d8d8;
        // box-sizing: border-box;
        // position: fixed;
        // width: 100%;
        // top: 0px;
        z-index: 999;
        background: #fff;
        .el-tabs__item {
            padding: 0 20px;
            height: 31px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            line-height: 30px;
            display: inline-block;
            list-style: none;
            font-size: 12px;
            font-weight: 500;
            position: relative;
            &.is-active {
                color: $theme-color;
                // border-bottom: 2px solid $theme-color;
                /* &::after{
                content: "";
                display: block;
                width: 100%;
                height: 2px;
                position: absolute;
                bottom: 0;
                left: 0;
                background-color: $theme-color;
              } */
            }
        }
        .el-tabs__header {
            margin: 0;
            .el-tabs__nav-wrap {
                background: #fff;
                .el-tabs__nav-prev,
                .el-tabs__nav-next {
                    top: 50% !important;
                    margin-top: -6px !important;
                    height: 100% !important;
                    line-height: 100% !important;
                }
            }
        }
        .el-tabs__nav-wrap {
            background: #fff;
        }
    }
    .aside_btn {
        padding: 9px 4px;
        border-radius: 0;
        border-top: 0;
        border-bottom: 0;
    }

    .main-inner {
        width: 100%;
        height: 100%;
        padding: 0 !important;
        position: relative;
        .tabCont,
        .table {
            * {
                font-size: 12px !important;
            }
        }
        .main-content {
            // height: calc(100% - 72px);
            height: 100%;
            .tableCont {
                .el-tabs__header {
                    margin: 0;
                    .el-tabs__item {
                        height: 36px;
                        line-height: 36px;
                        border-top: 3px solid transparent;
                        .label {
                            color: #000000;
                            i {
                                margin-right: 3px;
                            }
                        }
                    }
                    .is-active {
                        border-top-color: $theme-color;
                    }
                }
            }
            /* &::before{
                content: "";
                display: block;
                width: 100%;
                height: 10px;
                background: #f5f7fa;
            } */
            .table {
                border-top: 1px solid #dcdfe6;
                box-sizing: border-box;
                .link {
                    color: $theme-color;
                    text-decoration: underline;
                    cursor: pointer;
                    user-select: none;
                    &:hover {
                        opacity: 0.6;
                    }
                    &:active {
                        opacity: 0.8;
                    }
                }
            }
        }
    }
    .el-aside {
        height: 100%;
        .menuCont {
            margin-top: 40px;
            margin-bottom: 40px;
        }
        .el-scrollbar__wrap {
            background: $menu_bg;
            overflow-x: hidden;
            .slide-bar-wrap {
                .el-menu-item.is-active {
                    background: $menu_active !important;
                    color: $menu-text-active;
                }
                .el-menu-item,
                .el-submenu__title {
                    background: $menu_bg;
                    color: $menu-text;
                    font-size: 12px;
                    i {
                        color: $menu-text;
                    }
                    &:hover {
                        background: $menu_active !important;
                        color: $menu-text-active;
                    }
                }
            }
        }
    }
    .el-container {
        width: 100%;
        height: 100%;
    }
    .el-header {
        padding: 0 !important;
        height: 75px !important;
        border-bottom: 1px solid #d8d8d8;
        .header + .el-row {
            // border-top: 1px solid #d8d8d8;
        }
        .my-col {
            width: calc(100% - 22px);
        }
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        transform: translateX(50px);
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all 1s;
    }
}
</style>
